module.exports = __webpack_public_path__ + "img/plan2-min.0e6cd367.jpg";